module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Teufenthal-b816a1705733f621ae458c56b657d4d9.svg";